import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './Services.module.css';

const services = [
  {
    title: 'Web Design & Development',
    body: 'We create stunning, responsive websites that captivate your audience and drive conversions. From wireframes to deployment, every pixel is crafted to represent your brand.',
    icon: '🌐',
  },
  {
    title: 'Mobile App Development',
    body: 'We build high-performance iOS and Android applications with seamless UX. Our mobile solutions help businesses reach customers anywhere, anytime, on any device.',
    icon: '📱',
  },
  {
    title: 'Branding & Marketing',
    body: 'From identity design to digital campaigns, we build brands that resonate and stick. Strategy-led, creative-first, results-obsessed.',
    icon: '✦',
  },
  {
    title: 'Logistic & Shipping',
    body: 'End-to-end logistics management systems that streamline operations, reduce costs and deliver real-time visibility across your entire supply chain.',
    icon: '🚚',
  },
  {
    title: 'Expert Legal Consultant',
    body: 'Navigating legal complexities in the digital space? Our expert consultants help startups and enterprises mitigate risk, stay compliant and operate confidently.',
    icon: '⚖️',
  },
  {
    title: 'Business Consultant',
    body: 'We partner with leadership teams to develop winning strategies, improve operations, and unlock sustainable growth through data-driven insights.',
    icon: '📊',
  },
];

export default function Services() {
  useEffect(() => {
    const observerOptions = { root: null, rootMargin: '0px', threshold: 0.12 };

    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(styles.isVisible);
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);
    const revealElements = document.querySelectorAll('[data-reveal]');
    revealElements.forEach((el) => observer.observe(el));

    return () => revealElements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div className={styles.page}>

      {/* ── Hero Banner ── */}
      <section className={styles.hero}>
        <div className={`container ${styles.heroInner}`}>
          <div className={styles.reveal} data-reveal>
            <h1 className="section-title">
              Our Core Services
              <span className={styles.titleAccent} />
            </h1>
          </div>
          <div className={`${styles.heroBanner} ${styles.reveal}`} data-reveal style={{ transitionDelay: '0.15s' }}>
            <div className={styles.bannerText}>
              <span className={styles.bannerTag}>At Transvue Solutions India Private Limited, we offer a wide range of innovative IT services tailored to meet the unique needs of our clients. Our approach integrates strategy, design and engineering to develop seamless and scalable solutions that enhance productivity, improve efficiency and unlock new revenue streams.</span>
            </div>
            <div className={styles.bannerImg} />
          </div>
        </div>

        <div className={`${styles.sectionWave} ${styles.waveToLight}`} aria-hidden="true">
          <svg viewBox="0 0 1440 100" preserveAspectRatio="none">
            <path d="M0,0 C480,100 960,0 1440,80 L1440,100 L0,100 Z" />
          </svg>
        </div>
      </section>

      {/* ── Services Grid ── */}
      <section className={styles.grid}>
        <div className="container">
          <div className={styles.cardsGrid}>
            {services.map((svc, i) => (
              <div
                key={svc.title}
                className={`${styles.card} ${styles.reveal}`}
                data-reveal
                style={{ transitionDelay: `${i * 0.08}s` }}
              >
                <span className={styles.cardIconWrap}>
                  <span className={styles.cardIcon}>{svc.icon}</span>
                </span>
                <h3>{svc.title}</h3>
                <p>{svc.body}</p>
                <Link to="/contact-us" className={styles.cardLink}>
                  Get started <span className={styles.linkArrow}>→</span>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}